

export const ReportFormats = Object.freeze({
    PDF: "PDF",
    XLSX: "EXCEL"
});